import { getPosterDisplayUrl } from "utils/referralPosterUrl";

/**
 * @param {object} payload
 * @param {{ userName?: string, shareTime?: string, productName?: string, sideText?: string, profitCurrency?: string }} meta
 */
export function buildPositionShareSlides(payload, meta = {}) {
  if (!payload) return [];
  const { position, realTimePrice, realTimeProfitLossValue, isNegative } = payload;
  const image = getPosterDisplayUrl("position");
  return [
    {
      key: "position",
      image,
      bgImageUrl: image,
      variant: "position",
      posterData: {
        userName: meta.userName || "User",
        shareTime: meta.shareTime || "",
        pair: position?.pair || "",
        productName: meta.productName || "",
        sideText: meta.sideText || "",
        leverage: position?.leverage || "",
        pnlValue: realTimeProfitLossValue || "0",
        pnlUnit: meta.profitCurrency || "USDT",
        isNegative: !!isNegative,
        entryPrice: position?.entryPrice || "—",
        latestPrice: realTimePrice || "—",
      },
    },
  ];
}

/** AI 跟单策略详情分享（底图 poster-ai） */
export function buildAicopyDetailShareSlides({ strategyName, returnRate, aum }) {
  const image = getPosterDisplayUrl("aicopy");
  return [
    {
      key: "aicopy",
      image,
      bgImageUrl: image,
      variant: "aicopy",
      posterData: {
        strategyName: strategyName || "",
        returnRate: returnRate || "0%",
        aum: aum || "0",
      },
    },
  ];
}

/** AI 跟单订单列表分享（最多展示 2 条，底图 poster-ai） */
export function buildAicopyOrdersShareSlides(orders = []) {
  const image = getPosterDisplayUrl("aicopy");
  return [
    {
      key: "aicopy-orders",
      image,
      bgImageUrl: image,
      variant: "aicopyOrders",
      posterData: {
        orders: (Array.isArray(orders) ? orders : []).slice(0, 2).map((order) => ({
          id: order.id,
          name: order.name,
          returnRate: order.returnRate,
          tag: order.tag,
        })),
      },
    },
  ];
}

export function resolvePositionProfitCurrency(pair) {
  const p = String(pair || "").trim();
  if (!p) return "USDT";
  const parts = p.split("/");
  return parts.length >= 2 ? (parts[parts.length - 1] || "USDT").trim().toUpperCase() : "USDT";
}

/** 交易对分享：poster-position 底图，仅交易对 + 最新价（无持仓盈亏/方向/开仓价） */
export function buildPairShareSlides(payload, meta = {}) {
  if (!payload) return [];
  const image = getPosterDisplayUrl("position");
  return [
    {
      key: "pair",
      image,
      bgImageUrl: image,
      variant: "pair",
      posterData: {
        userName: meta.userName || "User",
        shareTime: meta.shareTime || "",
        pair: payload.pair || "",
        productName: meta.productName || payload.productName || "",
        latestPrice: payload.currentPrice || "—",
      },
    },
  ];
}
